import { CalculationEngineMonthlyValueOverrides, FarmerMarginCalculatorModel, RunCalculationEngineResponse } from '../../../../../../Generated/Raven-Demeter';
import { TrackingEvent } from '../../../../../Services/Tracking/TrackingService';
import { HideGroup, MarginCompositeModel, TabEventKeyType } from '../../../RiskDefinitions';
import MarginDataRow from '../MarginDataRow';
import MarginInputRow from '../MarginInputRow';
import styles from '../MarginInputsTable.module.scss';

interface IMarginInputsTableOutputHedgedDataProps {
    getFarmerMarginCalculatorCompositeRowsModel: MarginCompositeModel[];
    runCalculationEngineResponse: RunCalculationEngineResponse;
    savedFarmerMarginCalculator?: FarmerMarginCalculatorModel;
    hideGroup: HideGroup;
    runMonthlyValueOverrides: Array<CalculationEngineMonthlyValueOverrides> | null;
    setRunMonthlyValueOverrides: (runMonthlyValueOverrides: Array<CalculationEngineMonthlyValueOverrides> | null) => void;
    handleGridTabNavigation: (columnIndex: number, rowIndex: number, direction: TabEventKeyType) => void;
    track: TrackingEvent;
}

const MarginInputsTableOutputHedgedData: React.FC<IMarginInputsTableOutputHedgedDataProps> = (props: IMarginInputsTableOutputHedgedDataProps) => {
    const firstRowModel = props.getFarmerMarginCalculatorCompositeRowsModel[0];
    const showOutputHedgedChildren = props.hideGroup[firstRowModel.outputHedgedVolume.variableName] === false;
    const topLevelBackground = styles.margin_inputs_table_top_level_background;
    const level1Background = styles.margin_inputs_table_level_1_background;
    const level2Background = styles.margin_inputs_table_level_2_background;

    return (
        <>
            {props.hideGroup[firstRowModel.outputHedgedVolume.variableName] === false &&
                firstRowModel.outputHedgedVolume.children?.map((y) => {
                    const showGroupChildren = props.hideGroup[y.variableName] === false;
                    const level1Parents = [firstRowModel.outputHedgedVolume.variableName, firstRowModel.outputHedgedPrice.variableName];
                    const finalRow = (
                        <MarginInputRow
                            className={showGroupChildren ? level2Background : level1Background}
                            getFarmerMarginCalculatorCompositeRowsModel={props.getFarmerMarginCalculatorCompositeRowsModel}
                            ancestors={level1Parents}
                            hideGroup={props.hideGroup}
                            runCalculationEngineResponse={props.runCalculationEngineResponse}
                            disabled={showGroupChildren}
                            fieldName={y.variableName}
                            handleGridTabNavigation={props.handleGridTabNavigation}
                            runMonthlyValueOverrides={props.runMonthlyValueOverrides}
                            setRunMonthlyValueOverrides={props.setRunMonthlyValueOverrides}
                            savedFarmerMarginCalculator={props.savedFarmerMarginCalculator}
                            track={props.track}
                        />
                    );

                    if (showGroupChildren) {
                        return (
                            <>
                                {y.children?.map((z) => {
                                    const showSecondaryGroupChildren = z.children && props.hideGroup[z.variableName] === false;

                                    if (z.isReadOnly) {
                                        return (
                                            <MarginDataRow
                                                className={showSecondaryGroupChildren ? level1Background : level2Background}
                                                getFarmerMarginCalculatorCompositeRowsModel={props.getFarmerMarginCalculatorCompositeRowsModel}
                                                runCalculationEngineResponse={props.runCalculationEngineResponse}
                                                fieldName={z.variableName}
                                            />
                                        );
                                    }

                                    return (
                                        <MarginInputRow
                                            className={showSecondaryGroupChildren ? level1Background : level2Background}
                                            getFarmerMarginCalculatorCompositeRowsModel={props.getFarmerMarginCalculatorCompositeRowsModel}
                                            ancestors={[...level1Parents, y.variableName, ...(y.combinedWith?.map((x) => x.variableName) ?? [])]}
                                            hideGroup={props.hideGroup}
                                            runCalculationEngineResponse={props.runCalculationEngineResponse}
                                            fieldName={z.variableName}
                                            handleGridTabNavigation={props.handleGridTabNavigation}
                                            runMonthlyValueOverrides={props.runMonthlyValueOverrides}
                                            setRunMonthlyValueOverrides={props.setRunMonthlyValueOverrides}
                                            savedFarmerMarginCalculator={props.savedFarmerMarginCalculator}
                                            track={props.track}
                                        />
                                    );
                                })}
                                {finalRow}
                            </>
                        );
                    }

                    return finalRow;
                })}

            <MarginDataRow
                className={showOutputHedgedChildren ? level1Background : topLevelBackground}
                getFarmerMarginCalculatorCompositeRowsModel={props.getFarmerMarginCalculatorCompositeRowsModel}
                runCalculationEngineResponse={props.runCalculationEngineResponse}
                fieldName={firstRowModel.outputHedgedVolume.variableName}
                displayDecimalPlacesMinimum={0}
            />
            <MarginDataRow
                className={showOutputHedgedChildren ? level1Background : topLevelBackground}
                getFarmerMarginCalculatorCompositeRowsModel={props.getFarmerMarginCalculatorCompositeRowsModel}
                runCalculationEngineResponse={props.runCalculationEngineResponse}
                fieldName={firstRowModel.outputHedgedPrice.variableName}
            />
        </>
    );
};

export default MarginInputsTableOutputHedgedData;
